var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteRing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".9vw",
    height: ".9vw",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99854 7.50024L5.99854 3.30024L7.19854 1.50024H10.7985L11.9985 3.30024L8.99854 7.50024ZM11.6235 5.10024L10.7235 6.37524C12.3735 7.05024 13.4985 8.62524 13.4985 10.5002C13.4985 11.6937 13.0244 12.8383 12.1805 13.6822C11.3366 14.5261 10.192 15.0002 8.99854 15.0002C7.80506 15.0002 6.66047 14.5261 5.81656 13.6822C4.97264 12.8383 4.49854 11.6937 4.49854 10.5002C4.49854 8.62524 5.62354 7.05024 7.27354 6.37524L6.37354 5.10024C4.34854 6.07524 2.99854 8.10024 2.99854 10.5002C2.99854 12.0915 3.63068 13.6177 4.75589 14.7429C5.88111 15.8681 7.40724 16.5002 8.99854 16.5002C10.5898 16.5002 12.116 15.8681 13.2412 14.7429C14.3664 13.6177 14.9985 12.0915 14.9985 10.5002C14.9985 8.10024 13.6485 6.07524 11.6235 5.10024Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRing);
export default __webpack_public_path__ + "static/media/White_ring.aa4857cb398e79585583f280f718d1c8.svg";
export { ForwardRef as ReactComponent };